import {
  Uau,
  MandouBem,
  Valeu,
  Colaboracao,
  Inovacao,
  FocoNoCliente,
  Resolutividade,
  Lideranca,
  Selo,
  SeloRealizacao,
} from 'components/icons';
import { useEffect, useMemo, useState } from 'react';
import { format } from 'date-fns';
import { BiGift, BiTrophy, BiMailSend, BiInfoCircle, BiFootball } from 'react-icons/bi';
import { TbMailFast, TbTargetArrow } from 'react-icons/tb';
import { GetTaskLevelLabel } from 'utils/strings';
import { AiOutlineStar } from 'react-icons/ai';
import { getMonthName } from 'services/utils';
import { object } from 'prop-types';
import { FormatNumber, getMonthNameFromString } from 'utils/helpers';

import Envelope from '../../assets/img/festa-junina/envolope-icon.svg';
import LogoSimplifique from '../../assets/img/simplifique/logo.png';

import { ptBR } from 'date-fns/locale';
import { useAuth } from 'context/AuthContext';
import Tippy from '@tippyjs/react';
import { Divider } from 'rsuite';
import { MdQuiz } from 'react-icons/md';

const iconSize = 20;
const Coins: any = {
  uau: <Uau yellow size={iconSize} />,
  mandou: <MandouBem yellow size={iconSize} />,
  valeu: <Valeu yellow size={iconSize} />,
};

const CoinLabel: any = {
  uau: '#UAU',
  mandou: '#MANDOUBEM',
  valeu: '#VALEU',
};

const Behaviors: any = {
  colaboracao: <Colaboracao size={iconSize} />,
  inovacao: <Inovacao size={iconSize} />,
  foco: <FocoNoCliente size={iconSize} />,
  resolutividade: <Resolutividade size={iconSize} />,
  lideranca: <Lideranca size={iconSize} />,
};

const BehaviorLabel: any = {
  colaboracao: 'Colaboração',
  inovacao: 'Inovação',
  foco: 'Foco no Cliente',
  resolutividade: 'Protagonismo',
  lideranca: 'Liderança Integradora',
};

interface PointItemProps {
  data: any;
  cycleLabel?: string;
}

export function PointItem(props: PointItemProps) {
  const { data, cycleLabel } = props;
  const { realCycle } = useAuth();

  const behaviors = function (label?: string) {
    const _label = label || cycleLabel;

    return [
      {
        id: 'colaboracao',
        icon: <Selo size={'124px'} cycle={_label} selo="Colaboracao" />,
        smallIcon: <Selo size={'44px'} cycle={_label} selo="Colaboracao" />,
        extraSmallIcon: <Selo size={'22px'} cycle={_label} selo="Colaboracao" />,
      },
      {
        id: 'foco',
        icon: <Selo size={'124px'} cycle={_label} selo="Foco" />,
        smallIcon: <Selo size={'44px'} cycle={_label} selo="Foco" />,
        extraSmallIcon: <Selo size={'22px'} cycle={_label} selo="Foco" />,
      },
      {
        id: 'inovacao',
        icon: <Selo size={'124px'} cycle={_label} selo="Inovacao" />,
        smallIcon: <Selo size={'44px'} cycle={_label} selo="Inovacao" />,
        extraSmallIcon: <Selo size={'22px'} cycle={_label} selo="Inovacao" />,
      },
      {
        id: 'resolutividade',
        icon: <Selo size={'124px'} cycle={_label} selo="Resolutividade" />,
        smallIcon: <Selo size={'44px'} cycle={_label} selo="Resolutividade" />,
        extraSmallIcon: <Selo size={'22px'} cycle={_label} selo="Resolutividade" />,
      },
      {
        id: 'lideranca',
        icon: <Selo size={'124px'} cycle={_label} selo="Lideranca" />,
        smallIcon: <Selo size={'44px'} cycle={_label} selo="Lideranca" />,
        extraSmallIcon: <Selo size={'22px'} cycle={_label} selo="Lideranca" />,
      },
    ];
  };

  const galeria = [
    {
      id: 'galeria',
      icon: <Selo selo="Galeria" size={'124px'} cycle={cycleLabel} />,
    },
  ];

  const [origin, setOrigin] = useState<any>();
  const [taskOpened, setTaskOpened] = useState<boolean>(false);

  useEffect(() => {
    const defaultPoint = {
      type: 'default',
      title: 'Crédito de Pontos',
      total: data.total,
      time: data.time,
    };

    try {
      if (typeof data?.log === 'object' || (data?.log && data?.log.length)) {
        let log = typeof data?.log == 'object' ? data.log : data?.log[0];
        setOrigin({
          type: data.extra.type,
          extra: data.extra,
          log,
          total: data.total,
          time: data.time,
        });
      } else if (data.type) {
        setOrigin(data);
      } else {
        setOrigin(defaultPoint);
      }
    } catch (e) {
      setOrigin(defaultPoint);
    }
  }, [data]);

  function getIcon(key?: string, cycle?: string, extraSmall?: boolean) {
    if (!!key) {
      const icon = behaviors(cycle).filter(item => {
        return item.id === key;
      });

      if (extraSmall) {
        return icon[0].extraSmallIcon;
      }

      if (!!icon) {
        return icon[0].smallIcon;
      }
    }
  }

  function translateTitleBonus(title: string) {
    const _title = title ? title.replace(/Nível \d+ - /, '') : '';
    return _title;
  }

  function translateTitle(item: any) {
    if (item?.log?.attributes?.campanha === 'copa_2026') {
      return (
        <>
          <p className="text-gray-300 text-sm font-light mb-3">Álbum BB 2026</p>
          <p className="block text-base text-alice-blue m-0 font-normal">
            {item?.log?.attributes?.blocoNome ?? 'Seleção Joga Junto'}
          </p>
        </>
      );
    } else if (item?.log?.attributes?.campanha) {
      return (
        <>
          {!origin?.log?.attributes?.tag && !origin?.log?.attributes?.role && (
            <p className="text-gray-300 text-sm font-light mb-3">
              {item.log.attributes.campanha === 'Campanha de festa junina 2025' ? 'Arraiá do Reconhecimento' : 'Campanha'}
            </p>
          )}
          {item.log.attributes.campanha === 'Campanha de festa junina 2025' ? (
            <p className="block text-base text-alice-blue m-0 font-normal">Você enviou um Correio de Elogios</p>
          ) : (
            <p className="block text-base text-alice-blue m-0 font-normal">
              {(origin?.log?.attributes?.tag || origin?.log?.attributes?.role) ? '' : 'Você participou'}{' '}
              {`${
                item.log.attributes.campanha === 'agasalho_maio_2023'
                  ? 'da Campanha do Agasalho 2023'
                  : item.log.attributes.campanha === 'voluntariado_maio_2023'
                    ? 'do Jogando Juntos no Voluntariado'
                    : item.log.attributes.campanha
              }`}
            </p>
          )}
        </>
      );
    } else if (item?.log?.action === 'Entrou por convite') {
      return (
        <>
          <p className="text-gray-300 text-sm font-light mb-3">Ação</p>
          <p className="block text-base text-alice-blue m-0 font-normal">
            Convide seus amigos - Convite aceito por{' '}
            <span className="text-electric-blue capitalize">{item.extra.target_nome_guerra}</span>
          </p>
        </>
      );
    } else if (item?.log?.attributes?.desafio && item?.log?.attributes?.titulo_desafio) {
      return (
        <>
          <p className="text-gray-300 text-sm font-light mb-3">Desafio</p>
          <p className="block text-base text-alice-blue m-0 font-normal">
            Você participou {item?.log?.attributes?.preposicao ? item?.log?.attributes?.preposicao : 'do'}{' '}
            {item?.log?.attributes?.titulo_desafio}
          </p>
        </>
      );
    } else if (item?.log?.attributes?.type === 'challenge') {
      return (
        <>
          <p className="text-gray-300 text-sm font-light mb-3">Desafio</p>
          <p className="block text-base text-alice-blue m-0 font-normal">{item?.log?.attributes?.title}</p>
        </>
      );
    } else {
      return (
        <>
          <p className="text-gray-300 text-sm font-light mb-3">Desafio</p>
          <p className="block text-base text-alice-blue m-0 font-normal">
            Bônus de Colaboração - {translateTitleBonus(item?.log?.attributes?.fase)} - {cycleLabel}
          </p>
        </>
      );
    }
  }

  function getIconCampanha(item: any) {
    if (item?.log?.attributes?.campanha === 'copa_2026') {
      return <BiFootball className="text-[3rem] text-yellow" aria-label="Álbum BB 2026" />;
    } else if (item?.log?.attributes?.campanha === 'Campanha de festa junina 2025') {
      return <img src={Envelope} alt="Evelote Festa Junina" />;
    } else if (item?.log?.attributes?.tag || item?.log?.attributes?.role) {
      return <img src={LogoSimplifique} alt="Simplifique" className="h-[3rem] w-auto" />;
    } else if (item?.log?.attributes?.campanha || item?.log?.attributes?.desafio) {
      return <AiOutlineStar className="text-[3rem] text-yellow" />;
    } else if (
      item?.log?.attributes?.type === 'challenge' ||
      item?.log?.action === 'Realização Destaque: Pontos de Colaboração'
    ) {
      return <TbTargetArrow className="text-[3rem] text-yellow" />;
    } else {
      return <BiMailSend className="text-[3rem] text-yellow" />;
    }
  }

  function handleFaseTitle(item: any) {
    if (item.time >= 1741575600000) {
      if (item.faseTitle) {
        return getMonthNameFromString(item.faseTitle);
      }

      return format(new Date(item.task_time ?? item.task?.created ?? null), 'MMMM', { locale: ptBR });
    }

    if (item.time <= 1725159599999 || item.period === '1_mensal') return item.faseTitle;

    const name = item.period === '2_trimestral' ? 'Nível 2 -' : 'Nível 3 -';
    const month = format(new Date(item.task_time), 'MMMM', { locale: ptBR });

    return `${name} ${month}`;
  }

  // function translateTitle(item: any) {
  //   if (item?.log?.attributes?.campanha) {
  //     switch (item.log.attributes.campanha) {
  //       case 'agasalho_maio_2023':
  //         return 'Campanha do Agasalho 2023';
  //       case 'voluntariado_maio_2023':
  //         return 'Jogando Juntos no Voluntariado';
  //       default:
  //         return item.log.attributes.campanha;
  //     }
  //   }

  //   if (item?.log?.action === 'Entrou por convite') {
  //     return (
  //       <>
  //         <div className="flex flex-col">
  //           <span className="text-gray-3oo font-light text-sm leading-5">Convide seus amigos</span>
  //           <span className="text-gray-500 font-bold text-base leading-5 mt-3">
  //             Convite aceito por <span className="text-electric-blue capitalize">{item.extra.target_nome_guerra} </span>
  //             {`em ${format(new Date(item.time), 'dd MMM. yyyy')}.`}
  //           </span>
  //         </div>
  //       </>
  //     );
  //   }
  // }

  return useMemo(() => {
    function renderSeloBB() {
      try {
        return (
          <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-maastricht-blue-3 p-3 md:p-7 space-y-5 md:space-y-0 md:space-x-3 rounded-xl">
            <div className="flex flex-row space-x-3 items-center">
              <div>
                <BiTrophy size={30} className="text-yellow" />
              </div>
              <div className="flex-1">
                Recebeu o Selo BB em <b className="electric-blue">{origin.log.attributes.selo}</b>
              </div>
            </div>
            <div className="flex flex-row space-x-3 items-center justify-center">
              <div className="flex flex-row items-center space-x-2 px-2 text-yellow py-1 bg-oxford-blue rounded-full">
                <b>{FormatNumber(origin.total)} pontos</b>
              </div>
            </div>
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderMoedasBonus() {
      try {
        return (
          <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-maastricht-blue-3 p-3 md:p-7 space-y-5 md:space-y-0 md:space-x-3 rounded-xl">
            <div className="flex flex-row space-x-3 items-center">
              <div>
                <BiGift size={30} className="text-yellow" />
              </div>

              <div className="flex-1 text-lg leading-none">
                <p className="font-thin text-sm mb-2">Campanha</p>
                <p className="text-sm">
                  Voce participou do <b className="text-electric-blue">{origin.log.attributes.campanha}</b>
                </p>
              </div>
            </div>

            <div className="flex flex-row space-x-3 items-center justify-center">
              <div className="flex flex-row items-center space-x-2 px-2 bg-oxford-blue py-1 text-yellow rounded-full">
                {Behaviors[origin.extra.behavior]} <span className="text-xs">{BehaviorLabel[origin.extra.behavior]}</span>
              </div>

              <div className="flex flex-row items-center space-x-2 px-2 text-yellow py-1 bg-oxford-blue rounded-full">
                <b>+1</b> {Coins[origin.extra.coin]} <span className="text-xs">{CoinLabel[origin.extra.coin]}</span>
              </div>
            </div>
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderValoracaoGestor() {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-row space-x-3 items-center">
              <div className="flex-1 text-lg leading-none">
                {origin.time >= 1741575600000 ? (
                  <p className="font-normal text-sm">
                    Fase <span className="capitalize text-electric-blue">{handleFaseTitle(origin)}</span> - Validação da
                    Realização Destaque{' '}
                    {origin.hasExpired ? (
                      <span className="italic font-thin text-yellow">
                        &nbsp;&nbsp;&nbsp;Pontuação não creditada conforme IN 403-1 item <strong>6.4.9.2</strong>.{' '}
                        <Tippy
                          arrow={true}
                          allowHTML={true}
                          className="bg-black text-white font-thin rounded-xl p-2 tippy"
                          content={
                            <div>
                              <p>
                                IN 403-1:
                                <br />- <strong>6.4.9.2</strong> No caso de perda de prazo das etapas de validação e/ou das
                                apreciações níveis 1 e 2, conforme descrito no item <strong>7.4.6.5.4.8 Perda de Prazo</strong>,
                                os líderes responsáveis serão notificados da ocorrência.
                                <br />- <strong>6.4.9.2.1</strong> Em caso de reincidência, o líder não receberá a pontuação da
                                fase que perdeu o prazo.
                              </p>
                            </div>
                          }
                        >
                          <span className="-mt-[10px] ml-1 inline-block relative top-[6px]">
                            <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" />
                          </span>
                        </Tippy>
                      </span>
                    ) : (
                      ''
                    )}
                  </p>
                ) : !!origin.titlePoint ? (
                  <p className="font-normal text-sm">{origin.titlePoint}</p>
                ) : (
                  <p className="font-normal text-sm">
                    Validação da Realização Destaque - {origin.cicloTitle} - Fase {getMonthName(origin.fase)}
                  </p>
                )}
                {origin.task ? (
                  <p className="font-thin text-sm mt-1">
                    {origin.task.title}{' '}
                    <button
                      className="font-thin underline hover:no-underline text-electric-blue"
                      onClick={() => setTaskOpened(prevstate => !prevstate)}
                    >
                      {!taskOpened ? 'mais' : 'menos'}
                    </button>
                  </p>
                ) : null}
              </div>

              <div className="text-base leading-none">
                {/* <p className="font-thin text-xs mb-2 uppercase"></p> */}
                <b className="flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                  {FormatNumber(origin.total, false)}
                  <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                </b>
              </div>
            </div>

            {taskOpened && typeof origin.task.description === 'string' ? (
              <div>
                <p className="font-normal text-sm text-white">Detalhes da realização:</p>
                <p
                  className="font-thin text-sm text-white m-1"
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin.task.description === 'string'
                        ? origin.task.description.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>
            ) : null}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderValoracaoGestorFeedback() {
      try {
        return (
          <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-0 md:space-x-3 rounded-xl">
            <div className="flex-1 flex flex-row space-x-3 items-center">
              <div className="flex-1 text-lg leading-none">
                <p className="font-normal text-sm">
                  Feedback enviado nas Realizações Destaque avaliadas - {origin.cicloTitle} - Fase {getMonthName(origin.fase)}
                </p>
              </div>

              <div className="text-base leading-none">
                {/* <p className="font-thin text-xs mb-2 uppercase"></p> */}
                <b className="flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                  {FormatNumber(origin.total, false)}
                  <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                </b>
              </div>
            </div>
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderBonusGestorColaboracao() {
      try {
        return (
          <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-0 md:space-x-3 rounded-xl">
            <div className="flex-1 flex flex-row space-x-3 items-center">
              <div className="flex-1 text-lg leading-none">
                <p className="font-normal text-sm">
                  Bônus Colaboração {'('}IN 403-1 item 7.2.6.5.3.15.10{')'} - {origin.cicloTitle} - Fase{' '}
                  {getMonthName(origin.fase)}
                </p>
              </div>

              <div className="text-base leading-none">
                {/* <p className="font-thin text-xs mb-2 uppercase"></p> */}
                <b className="flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                  {FormatNumber(origin.total, false)}
                  <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                </b>
              </div>
            </div>
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderBonusGestorPrazo() {
      try {
        return (
          <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-0 md:space-x-3 rounded-xl">
            <div className="flex-1 flex flex-row space-x-3 items-center">
              <div className="flex-1 text-lg leading-none">
                <p className="font-normal text-sm">
                  Bônus por realizar as apreciações das realizações dentro do prazo - {origin.cicloTitle} - Fase{' '}
                  {getMonthName(origin.fase)}
                </p>
              </div>

              <div className="text-base leading-none">
                {/* <p className="font-thin text-xs mb-2 uppercase"></p> */}
                <b className="flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                  {FormatNumber(origin.total, false)}
                  <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                </b>
              </div>
            </div>
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    // function renderEntregaEquipe(isPlublic?: boolean) {
    //   try {
    //     return (
    //       <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
    //         <div className="flex-1 flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-3 md:items-center">
    //           {/* <div>
    //             {origin.status === 'aprovado' ? <RiThumbUpLine size={24} className="text-yellow" /> : null}
    //             {origin.status === 'dobrado' ? <BiCoinStack size={24} className="text-yellow" /> : null}
    //             {origin.status === 'promovido' ? <BiUpvote size={24} className="text-yellow" /> : null}
    //             {origin.status === 'selo' ? <BiTrophy size={24} className="text-yellow" /> : null}
    //           </div> */}
    //           {/* <div className="flex-1">
    //             <b>{origin.titulo}</b>
    //           </div> */}

    //           <div className="flex-1 text-lg leading-none">
    //             <p className="font-thin text-sm text-gray-300">Nome da realização</p>
    //             <p className="font-bold text-base mt-1 text-gray-500">{origin.titulo}</p>
    //           </div>

    //           <div className="flex-1 text-lg leading-none">
    //             <p className="font-thin text-sm text-gray-300">Fase</p>
    //             <p className="font-bold text-base mt-1 text-gray-500">{origin.faseTitle}</p>
    //           </div>

    //           <div className="flex-1 text-lg leading-none">
    //             <p className="font-thin text-sm text-gray-300">Status da entrega</p>
    //             <p className="font-bold text-base mt-1 text-gray-500">{GetTaskLevelLabel(origin.status)}</p>
    //           </div>

    //           <div className="text-base leading-none">
    //             <p className="font-thin text-sm mb-3 text-gray-300">{isPlublic ? 'Pontos da realização' : 'Atuação'}</p>

    //             <div className="flex">
    //               {origin?.participacao ? (
    //                 <b className="inline-flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none mr-3">
    //                   {origin.participacao}%
    //                   {/* <span className="block font-thin text-[10px] mt-1 uppercase leading-none">
    //                   Participação
    //                 </span> */}
    //                 </b>
    //               ) : null}

    //               {origin?.total ? (
    //                 <b className="flex flex-row items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
    //                   {FormatNumber(origin.total, false)}
    //                   <span className="font-thin text-[10px] mt-1 uppercase leading-none">pts</span>
    //                 </b>
    //               ) : null}
    //             </div>
    //           </div>
    //         </div>

    //         {typeof origin.descricao === 'string' && (
    //           <div>
    //             <p className="font-normal text-sm text-gray-300">Detalhes da realização:</p>
    //             <p
    //               className="font-bold text-base text-gray-500 m-1 "
    //               dangerouslySetInnerHTML={{
    //                 __html:
    //                   typeof origin.descricao === 'string'
    //                     ? origin.descricao.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
    //                     : '',
    //               }}
    //             />
    //           </div>
    //         )}
    //         {/* <div className="flex flex-row space-x-3 items-center justify-center">
    //           <div className="flex flex-row items-center space-x-2 px-2 text-white py-1 bg-purple rounded-full">
    //             <b>Participação: {origin.participacao}%</b>
    //           </div>
    //           <div className="flex flex-row items-center space-x-2 px-2 text-blue-dark py-1 bg-yellow rounded-full">
    //             <b>+{origin.total} pontos</b>
    //           </div>
    //         </div> */}
    //       </div>
    //     );
    //   } catch (e) {
    //     return null;
    //   }
    // }

    function renderEntregaEquipe(isPlublic?: boolean) {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-row space-x-3 items-center" tabIndex={0}>
              <div className="flex-1 text-lg leading-none">
                {origin.time >= 1741575600000 ? (
                  <p className="font-normal text-sm">
                    Fase <span className="capitalize text-electric-blue">{handleFaseTitle(origin)}</span> - Participação em
                    Realização Destaque
                  </p>
                ) : !!origin.titlePoint ? (
                  <p className="font-normal text-sm">{origin.titlePoint}</p>
                ) : (
                  <p className="font-normal text-sm">
                    Participação em Realização Destaque - {origin.cicloTitle} - Fase {handleFaseTitle(origin)}
                  </p>
                )}

                {origin.titulo ? (
                  <p className="font-thin text-sm mt-1">
                    {origin.titulo}{' '}
                    <button
                      className="font-thin underline hover:no-underline text-electric-blue"
                      onClick={() => setTaskOpened(prevstate => !prevstate)}
                    >
                      {!taskOpened ? 'mais' : 'menos'}
                    </button>
                  </p>
                ) : null}
              </div>

              <div className="flex text-base leading-none">
                {/* <p className="font-thin text-xs mb-2 uppercase"></p> */}
                {origin?.participacao ? (
                  <b className="inline-flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none mr-3">
                    {origin.participacao}%
                    {/* <span className="block font-thin text-[10px] mt-1 uppercase leading-none">
                      Participação
                    </span> */}
                  </b>
                ) : null}
                <b className="flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                  {FormatNumber(origin.total, false)}
                  <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                </b>
              </div>
            </div>

            {taskOpened && typeof origin.descricao === 'string' ? (
              <div tabIndex={0}>
                <p className="font-normal text-sm text-white">Detalhes da realização:</p>
                <p
                  className="font-thin text-sm text-white m-1"
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin.descricao === 'string'
                        ? origin.descricao.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>
            ) : null}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderEntregaEquipeEcoa(isPlublic?: boolean) {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-row space-x-3 items-center" tabIndex={0}>
              <div className="flex-1 text-lg leading-none">
                <p className="font-normal text-sm">
                  Participação em Ação ECOA - {origin.cicloTitle} - Fase{' '}
                  {origin?.period === '3_semestral'
                    ? realCycle?.find((e: any) => e.label === cycleLabel)?.steps.find(e => e.title === origin.faseTitle)
                        ?.semester_title
                    : origin.faseTitle}
                </p>
                {origin.titulo ? (
                  <p className="font-thin text-sm mt-1">
                    {origin.titulo}{' '}
                    <button
                      className="font-thin underline hover:no-underline text-electric-blue"
                      onClick={() => setTaskOpened(prevstate => !prevstate)}
                    >
                      {!taskOpened ? 'mais' : 'menos'}
                    </button>
                  </p>
                ) : null}
              </div>

              <div className="flex text-base leading-none">
                <b className="flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                  {FormatNumber(origin.total, false)}
                  <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                </b>
              </div>
            </div>

            {taskOpened && typeof origin.descricao === 'string' ? (
              <div tabIndex={0}>
                <p className="font-normal text-sm text-white">Detalhes da ação:</p>
                <p
                  className="font-thin text-sm text-white m-1"
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin.descricao === 'string'
                        ? origin.descricao.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>
            ) : null}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderDestaqueCultura() {
      return (
        <div className="grid grid-cols-2 items-center gap-8 w-fit rounded-2xl">
          {behaviors()?.map(behavior => (
            <div
              className={`${data?.items?.find((item: any) => item.behavior === behavior.id) ? '' : 'opacity-20'}`}
              key={behavior.id}
            >
              <div>{behavior.icon}</div>
            </div>
          ))}
        </div>
      );
    }

    function renderDestaqueCulturaCondensed() {
      return (
        <div className="grid grid-cols-1 lg:grid-cols-3 items-center lg:gap-8 w-fit rounded-2xl">
          {origin.items
            .filter((item: any) => {
              return !!item.behavior;
            })
            .map((item: any) => (
              <div className="flex flex-row" key={item.behavior}>
                <div className="icon bg-maastricht-blue p-1 h-[30px] w-[30px] mr-1 block rounded-md">
                  {getIcon(item.behavior, item?.cycle, true)}
                </div>
                <div className="flex flex-col justify-center">
                  {/* <span className="text-grey-dark text-sm lg:text-xs font-medium mb-1">
                    {origin.items[index]?.position}
                  </span> */}
                  <h4 className="text-[#5E7A90] lg:text-[10px] text-base font-normal leading-3">
                    {BehaviorLabel[item.behavior]}
                  </h4>
                </div>
              </div>
            ))}

          {origin.items
            .filter((item: any) => {
              return !item.behavior && !item.type;
            })
            .map((item: any) => (
              <div className="flex flex-row" key={item.behavior + item._id}>
                <div className="icon bg-maastricht-blue p-1 h-[30px] w-[30px] mr-1 block rounded-md">
                  <Selo selo="Galeria" size={22} cycle={cycleLabel ? cycleLabel : item.cycle} />
                </div>
                <div className="flex flex-col justify-center">
                  <h4 className="text-[#5E7A90] lg:text-[10px] text-base font-normal leading-3">Galeria do reconhecimento</h4>
                </div>
              </div>
            ))}

          {origin.items
            .filter((item: any) => {
              return item.type === 'realizacao';
            })
            .map((item: any) => (
              <div className="flex flex-row" key={item.realizacao + item._id}>
                <div className="icon bg-maastricht-blue p-1 h-[30px] w-[30px] mr-1 block rounded-md">
                  <Selo selo="Realizacao" size={22} cycle={cycleLabel ? cycleLabel : item.cycle} />
                </div>
                <div className="flex flex-col justify-center">
                  <h4 className="text-[#5E7A90] lg:text-[10px] text-base font-normal leading-3">Realização Destaque</h4>
                </div>
              </div>
            ))}
        </div>
      );
    }

    function renderDestaqueCulturaIcon() {
      return (
        <div className="bg-[#022138] w-[60px] h-[60px] rounded-[3px] flex justify-center items-center">
          {origin.behavior ? (
            getIcon(origin.behavior, origin?.cycle)
          ) : origin.typeItem ? (
            <Selo selo="Realizacao" size={44} cycle={origin.cycle} />
          ) : (
            <Selo selo="Galeria" size={44} cycle={origin.cycle} />
          )}
        </div>
      );
    }

    function renderGaleria() {
      return (
        <div className="flex items-center space-x-8 w-fit rounded-2xl">
          {galeria.map(galeria => (
            <div className={`${!!data ? '' : 'opacity-20'}`} key={galeria.id}>
              <div>{galeria.icon}</div>
            </div>
          ))}
        </div>
      );
    }
    function renderSeloRealizacaoDestaque() {
      return (
        <div className="flex items-center space-x-8 w-fit rounded-2xl">
          <div className={`${!!data ? '' : 'opacity-20'}`}>
            <div>
              <SeloRealizacao selo="Realizacao" size={'124px'} cycle={cycleLabel} />
            </div>
          </div>
        </div>
      );
    }

    function renderSeloRealizacao() {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-24">
              {/* <div>
                {origin.status === 'aprovado' ? <RiThumbUpLine size={24} className="text-yellow" /> : null}
                {origin.status === 'dobrado' ? <BiCoinStack size={24} className="text-yellow" /> : null}
                {origin.status === 'promovido' ? <BiUpvote size={24} className="text-yellow" /> : null}
                {origin.status === 'selo' ? <BiTrophy size={24} className="text-yellow" /> : null}
              </div> */}
              {/* <div className="flex-1">
                <b>{origin.titulo}</b>
              </div> */}

              <div className="flex-1 text-lg leading-none" tabIndex={0}>
                <p className="font-bold text-base text-gray-300">Nome da realização</p>
                <p className="font-thin text-sm mt-1 text-gray-500">{origin.titulo}</p>
              </div>

              <div className="font-bold text-base leading-none" tabIndex={0} aria-label={`Pontuação da realização: ${origin?.total ? FormatNumber(origin.total, false) : 0} pontos`}>
                <p className="font-bold text-base mb-3 text-gray-300">Pontuação da realização</p>

                <div className="flex">
                  {origin?.total ? (
                    <b className="flex flex-row items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                      {FormatNumber(origin.total, false)}
                    </b>
                  ) : null}
                </div>
              </div>

              <div className="text-lg leading-none" tabIndex={0} role="img" aria-label="Selo conquistado: Realização Destaque">
                <p className="font-bold text-base mb-3 text-gray-300" aria-hidden="true">Selo conquistado</p>

                <div className="mt-1 flex justify-center" aria-hidden="true">
                  <Selo selo="Realizacao" size={70} cycle={cycleLabel} />
                </div>
              </div>
            </div>

            {typeof origin.descricao === 'string' && (
              <div tabIndex={0}>
                <p className="font-bold text-base text-gray-300">Detalhes da realização:</p>
                <p
                  className="font-thin text-sm text-gray-500 m-1 "
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin.descricao === 'string'
                        ? origin.descricao.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>
            )}
            {/* <div className="flex flex-row space-x-3 items-center justify-center">
              <div className="flex flex-row items-center space-x-2 px-2 text-white py-1 bg-purple rounded-full">
                <b>Participação: {origin.participacao}%</b>
              </div>
              <div className="flex flex-row items-center space-x-2 px-2 text-blue-dark py-1 bg-yellow rounded-full">
                <b>+{origin.total} pontos</b>
              </div>
            </div> */}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderRealizacaoColetiva() {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-24">
              {/* <div>
                {origin.status === 'aprovado' ? <RiThumbUpLine size={24} className="text-yellow" /> : null}
                {origin.status === 'dobrado' ? <BiCoinStack size={24} className="text-yellow" /> : null}
                {origin.status === 'promovido' ? <BiUpvote size={24} className="text-yellow" /> : null}
                {origin.status === 'selo' ? <BiTrophy size={24} className="text-yellow" /> : null}
              </div> */}
              {/* <div className="flex-1">
                <b>{origin.titulo}</b>
              </div> */}

              <div className="flex-1 text-lg leading-none">
                <p className="font-bold text-base text-gray-300">Nome da realização</p>
                <p className="font-thin text-sm mt-1 text-gray-500">{origin.title}</p>
              </div>

              <div className="flex-1 text-lg leading-none">
                <p className="font-bold text-base text-gray-300">Fase</p>
                <p className="font-thin text-sm mt-1 text-gray-500">{origin.fase}</p>
              </div>

              <div className="flex-1 text-lg leading-none">
                <p className="font-bold text-base text-gray-300">Status da entrega</p>
                <p className="font-thin text-sm mt-1 text-gray-500">{origin.status}</p>
              </div>

              <div className="text-base leading-none">
                <p className="font-bold text-base mb-3 text-gray-300">Pontuação da realização</p>

                <div className="flex">
                  {origin?.total ? (
                    <b className="flex flex-row items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                      {FormatNumber(origin.total, false)}
                    </b>
                  ) : null}
                </div>
              </div>
            </div>

            {typeof origin.description === 'string' && (
              <div>
                <p className="font-bold text-base text-gray-300">Detalhes da realização:</p>
                <p
                  className="font-thin text-sm text-gray-500 m-1 "
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin.description === 'string'
                        ? origin.description.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>
            )}
            {/* <div className="flex flex-row space-x-3 items-center justify-center">
              <div className="flex flex-row items-center space-x-2 px-2 text-white py-1 bg-purple rounded-full">
                <b>Participação: {origin.participacao}%</b>
              </div>
              <div className="flex flex-row items-center space-x-2 px-2 text-blue-dark py-1 bg-yellow rounded-full">
                <b>+{origin.total} pontos</b>
              </div>
            </div> */}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderRealizacaoPremiada() {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-24">
              {/* <div>
                {origin.status === 'aprovado' ? <RiThumbUpLine size={24} className="text-yellow" /> : null}
                {origin.status === 'dobrado' ? <BiCoinStack size={24} className="text-yellow" /> : null}
                {origin.status === 'promovido' ? <BiUpvote size={24} className="text-yellow" /> : null}
                {origin.status === 'selo' ? <BiTrophy size={24} className="text-yellow" /> : null}
              </div> */}
              {/* <div className="flex-1">
                <b>{origin.titulo}</b>
              </div> */}

              <div className="flex-1 text-lg leading-none">
                <p className="font-bold text-base text-gray-300">Nome da realização</p>
                <p className="font-thin text-sm mt-1 text-gray-500">
                  {origin?.task?.title ? origin?.task?.title : origin.titulo}
                </p>
              </div>
            </div>

            {(typeof origin.descricao === 'string' || typeof origin?.task?.description === 'string') && (
              <div>
                <p className="font-bold text-base text-gray-300">Detalhes da realização:</p>
                <p
                  className="font-thin text-sm text-gray-500 m-1 "
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin?.task?.description === 'string'
                        ? origin.task.description.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : origin.descricao.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;'),
                  }}
                />
              </div>
            )}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderCampanhaBonus() {
      try {
        return (
          <div
            className="flex flex-col lg:flex-row lg:items-center lg:justify-between bg-maastricht-blue-3 p-3 lg:py-10 lg:px-16 space-y-5 lg:space-y-0 lg:space-x-3 rounded-xl"
            tabIndex={0}
          >
            <div className="flex flex-row space-x-3 items-center">
              <div>{getIconCampanha(origin)}</div>
              <div className="flex-1">{translateTitle(origin)}</div>
            </div>
            <div className="flex flex-row space-x-3 items-center justify-center">
              <div className="flex flex-row items-center space-x-2 px-3 bg-oxford-blue py-1 text-yellow rounded-full">
                <b>{FormatNumber(origin.total, false)} pontos</b>
              </div>
            </div>
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderQuizBonus() {
      try {
        return (
          <div
            className="flex flex-col lg:flex-row lg:items-center lg:justify-between bg-maastricht-blue-3 p-3 lg:py-10 lg:px-16 space-y-5 lg:space-y-0 lg:space-x-3 rounded-xl"
            tabIndex={0}
          >
            <div className="flex flex-row space-x-3 items-center">
              <div>
                <MdQuiz className="text-[3rem] text-yellow" />
              </div>
              <div className="flex-1">
                <p className="text-gray-300 text-sm font-light mb-1">Responder ao QUIZ</p>
                <p className="block text-base text-alice-blue m-0 font-normal">{origin?.log?.action}</p>
              </div>
            </div>
            <div className="flex flex-row space-x-3 items-center justify-center">
              <div className="flex flex-row items-center space-x-2 px-3 bg-oxford-blue py-1 text-yellow rounded-full">
                <b>{FormatNumber(origin.total, false)} pontos</b>
              </div>
            </div>
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderDefault() {
      return (
        <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
          <div className="flex-1 flex flex-row space-x-3 items-center" tabIndex={0}>
            <div className="flex-1 flex flex-row space-x-3 items-center">
              <div>{getIconCampanha(origin)}</div>
              <div className="flex-1">
                {translateTitle(origin)}
                {origin?.log?.attributes?.tag || origin?.log?.attributes?.role ? (
                  <div className="mt-2 flex items-center space-x-2">
                    {origin?.log?.attributes?.description} #{origin?.log?.attributes?.number}{' '}
                    {origin?.log?.attributes?.tag ? '#' + origin?.log?.attributes?.tag : ''}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="flex flex-row space-x-3 items-center justify-center">
              <div className="flex flex-row items-center space-x-2 px-3 bg-oxford-blue py-1 text-yellow rounded-full">
                <b>{FormatNumber(origin.total, false)} pontos</b>
              </div>
            </div>{' '}
          </div>

          {origin?.log?.attributes?.tag && taskOpened ? (
            <div tabIndex={0} className="ml-[61px] mt-3">
              <p className="font-normal text-sm text-white mb-2">Detalhes da ideia:</p>
              <p className="font-thin text-sm text-white">
                Número: {origin?.log?.attributes?.number} | Tag: {origin?.log?.attributes?.tag}
              </p>
              <p className="font-thin text-sm text-white mt-1">Título: {origin?.log?.attributes?.description}</p>
            </div>
          ) : null}
        </div>
      );
    }

    if (!origin) return null;

    if (origin.type === 'actions' && origin.extra.origin === 'quiz_natal2025') {
      return renderQuizBonus();
    }

    switch (origin.type) {
      case 'moedas_bonus':
        return renderMoedasBonus();
      case 'selobb':
        return renderSeloBB();
      case 'destaque_cultura':
        return renderDestaqueCultura();
      case 'destaque_cultura_condensed':
        return renderDestaqueCulturaCondensed();
      case 'destaque_cultura_icon':
        return renderDestaqueCulturaIcon();
      case 'entrega_equipe':
        return renderEntregaEquipe();
      case 'entrega_equipe_ecoa':
        return renderEntregaEquipeEcoa();
      case 'entrega_equipe_public':
        return renderEntregaEquipe(true);
      case 'entrega_gestor':
        return renderValoracaoGestor();
      case 'feedback_gestor':
        return renderValoracaoGestorFeedback();
      case 'bonus_colaboracao_gestor':
        return renderBonusGestorColaboracao();
      case 'pontos_bonus_prazo_gestor':
        return renderBonusGestorPrazo();
      case 'galeria':
        return renderGaleria();
      case 'selo_realizacao_destaque':
        return renderSeloRealizacaoDestaque();
      case 'selo_realizacao':
        return renderSeloRealizacao();
      case 'realizaca_premiada_coletiva':
        return renderRealizacaoColetiva();
      case 'realizaca_premiada':
        return renderRealizacaoPremiada();
      case 'campaign_bonus':
        return renderCampanhaBonus();
      default:
        return renderDefault();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [origin, taskOpened, behaviors, data, cycleLabel, galeria]);
}
